
const btn_2 = document.querySelector(".list-view-switch__trigger-2-column");
const btn_4 = document.querySelector(".list-view-switch__trigger-4-column");
const btn_6 = document.querySelector(".list-view-switch__trigger-6-column");

btn_2.addEventListener("click", function () {
  const grid = document.getElementsByClassName("product_grid_main")[0];
  if(grid.classList.contains('medium-up-4')) {
    document.getElementsByClassName("product_grid_main")[0].classList.remove("medium-up-4");
    document.getElementsByClassName("product_grid_main")[0].classList.add("medium-up-2");    
    document.querySelector(".list-view-switch__trigger-4-column svg").classList.remove("svg_active");  
    document.querySelector(".list-view-switch__trigger-2-column svg").classList.add("svg_active");   
  }
  if(grid.classList.contains('medium-up-6')) {
    document.getElementsByClassName("product_grid_main")[0].classList.remove("medium-up-6");
    document.getElementsByClassName("product_grid_main")[0].classList.add("medium-up-2");    
    document.querySelector(".list-view-switch__trigger-6-column svg").classList.remove("svg_active");  
    document.querySelector(".list-view-switch__trigger-2-column svg").classList.add("svg_active");   
  }
});

btn_4.addEventListener("click", function () {
  const grid = document.getElementsByClassName("product_grid_main")[0];
  if(grid.classList.contains('medium-up-2')) {
    document.getElementsByClassName("product_grid_main")[0].classList.remove("medium-up-2");
    document.getElementsByClassName("product_grid_main")[0].classList.add("medium-up-4");
    document.querySelector(".list-view-switch__trigger-2-column svg").classList.remove("svg_active");  
    document.querySelector(".list-view-switch__trigger-4-column svg").classList.add("svg_active");  
  }
  if(grid.classList.contains('medium-up-6')) {
    document.getElementsByClassName("product_grid_main")[0].classList.remove("medium-up-6");
    document.getElementsByClassName("product_grid_main")[0].classList.add("medium-up-4");    
    document.querySelector(".list-view-switch__trigger-6-column svg").classList.remove("svg_active");  
    document.querySelector(".list-view-switch__trigger-4-column svg").classList.add("svg_active");   
  }
});

btn_6.addEventListener("click", function () { 
  const grid = document.getElementsByClassName("product_grid_main")[0];
  if(grid.classList.contains('medium-up-2')) {
    document.getElementsByClassName("product_grid_main")[0].classList.remove("medium-up-2");
    document.getElementsByClassName("product_grid_main")[0].classList.add("medium-up-6");
    document.querySelector(".list-view-switch__trigger-2-column svg").classList.remove("svg_active");  
    document.querySelector(".list-view-switch__trigger-6-column svg").classList.add("svg_active");  
  }
  if(grid.classList.contains('medium-up-4')) {
    document.getElementsByClassName("product_grid_main")[0].classList.remove("medium-up-4");
    document.getElementsByClassName("product_grid_main")[0].classList.add("medium-up-6");    
    document.querySelector(".list-view-switch__trigger-4-column svg").classList.remove("svg_active");  
    document.querySelector(".list-view-switch__trigger-6-column svg").classList.add("svg_active");   
  }
});